import { BioLibSingleton } from '@biolibtech/biolib-js';
import { put, takeLatest, fork, call, select, race, take, delay } from 'redux-saga/effects';
import { reFetchUser } from '../../sagas/userSaga';
import notificationActions from '../../state/notification/notificationActions';
import { handleError } from '../../utils';
import accountSettingsSlice from './accountSettingsSlice';
import { IRootState } from '../../state/rootReducer';
import { navigate } from 'gatsby';
import userConstants from '../../state/user/userConstants';
import config from '../../config';

function* watchTeamAcceptInvitation() {
    yield takeLatest(accountSettingsSlice.actions.teamAcceptInvitation, function* (action) {
        if (accountSettingsSlice.actions.teamAcceptInvitation.match(action)) {
            try {
                let isSignedIn: boolean = yield select((state: IRootState) => state.user.isSignedIn);

                if (!isSignedIn) {
                    const { signInSuccess } = yield race({
                        signInSuccess: take(userConstants.SIGN_IN_SUCCESS),
                        timeout: delay(3000),
                    })
                    if (signInSuccess) {
                        isSignedIn = true;
                    }
                }

                if (!isSignedIn) {
                    yield put(notificationActions.addInfo('Sign in to accept the invitation'));
                    // TODO: Implement sign in action that takes a callback url with parameters that should be
                    //  returned to after sign in instead of using local storage
                    localStorage.setItem(config.localStorageKey.teamInvitation, JSON.stringify(action.payload));
                    yield navigate('/sign-in/');
                    return;
                }

                yield navigate('/');
                const biolib = BioLibSingleton.get();
                yield biolib.account.acceptInvitation(action.payload);
                yield put(accountSettingsSlice.actions.teamAcceptInvitationSuccess());
                yield call(reFetchUser);
                yield put(notificationActions.addSuccess('Successfully joined the team'));
            } catch (error) {
                yield call(handleError, {
                    error,
                    actionToDispatch: accountSettingsSlice.actions.teamAcceptInvitationFailure,
                    friendlyErrorMessageToPrepend: 'Failed to accept team invitation',
                    showToast: true,
                })
            }
        }
    })
}

function* watchSignInSuccess() {
    yield takeLatest(userConstants.SIGN_IN_SUCCESS, function* () {
        try {
            const teamInvitationJsonString = localStorage.getItem(config.localStorageKey.teamInvitation);
            if (teamInvitationJsonString) {
                localStorage.removeItem(config.localStorageKey.teamInvitation);
                const teamInvitation = JSON.parse(teamInvitationJsonString);
                const biolib = BioLibSingleton.get();
                yield biolib.account.acceptInvitation(teamInvitation);
                yield put(accountSettingsSlice.actions.teamAcceptInvitationSuccess());
                yield call(reFetchUser);
                yield put(notificationActions.addSuccess('Successfully joined the team'));
            }
        } catch (error) {
            yield call(handleError, {
                error,
                actionToDispatch: accountSettingsSlice.actions.teamAcceptInvitationFailure,
                friendlyErrorMessageToPrepend: 'Failed to accept team invitation',
                showToast: true,
            })
        }
    })
}

export default function* accountSettingsSaga() {
    yield fork(watchSignInSuccess);
    yield fork(watchTeamAcceptInvitation);
}
